import styled from '@emotion/styled';
import React from 'react';
import { breakpoints, colors } from '../../../utils/styleguide';
import PlayArrow from './PlayArrow';

const PlayArrowWrapper = styled.div`
  position: absolute;
  left: 35%;
  top: 50%;
  transform: translate(0, -50%);
`;

const PlayOverlay = styled.button`
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 40px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.3);
  background-blend-mode: multiply;
  border: 2px solid #ffffff;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  &:hover,
  &:active,
  &:focus {
    outline: none;
  }
  ${breakpoints.desktop} {
    width: 104px;
    height: 104px;
    border-radius: 53px;
  }
`;

/**
 *
 * @param {object} props
 * @param {function(*):void} props.onClick
 */
export const PlayButton = ({ onClick }: { onClick?: () => void }) => {
  return (
    <PlayOverlay onClick={onClick} aria-label="Play">
      <PlayArrowWrapper>
        <PlayArrow size="L" color={colors.white} />
      </PlayArrowWrapper>
    </PlayOverlay>
  );
};
